import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "forms/forms.css";

const FormContainer = ({ children, hasSeparator, title }) => (
  <div className={cx(styles.container, { [styles.border]: hasSeparator })}>
    {title && <div className={styles.title}>{title}</div>}
    <div className={styles.body}>{children}</div>
  </div>
);

FormContainer.propTypes = {
  children: PropTypes.node.isRequired,
  hasSeparator: PropTypes.bool,
  title: PropTypes.string,
};

FormContainer.defaultProps = {
  hasSeparator: true,
};

export default FormContainer;
